export class IdPUserRequest {
	id: number;
	idpId: number;
	username: string;
	firstName: string;
	lastName: string;
	cardId: string;
	phoneNumber: string;
	groupNames: string;

	constructor(){
		this.id = 0;
		this.idpId = 0;
		this.firstName = '';
		this.lastName = '';
		this.cardId = '';
		this.phoneNumber = '';
		this.groupNames = '';
	}
 }
